import tippy, { followCursor } from 'tippy.js';
import confetti from 'canvas-confetti';
import Command from '../general/Command';

let cameraFeedEnabled = true;
let cameraMuted = true;

let manager;

const hostMutedCommand = new Command('host_muted_video', (data) => {
  $('#viewportPlaceholderText').toggleClass('hidden', data.args.cameraEnabled);
});

function setupVideoSizeListeners() {
  const localVideo = document.querySelector('#localVideo');
  if (localVideo !== null) {
    localVideo.addEventListener('resize', () => {
      tippy('#videoWrapper', {
        content: `Source: ${localVideo.videoWidth}x${localVideo.videoHeight}`,
        followCursor: true,
        plugins: [followCursor],
      });
    });
  }

  const remoteVideo = document.querySelector('#remoteVideo');
  if (remoteVideo !== null) {
    remoteVideo.addEventListener('resize', () => {
      console.log(`resize: Remote video size changed to ${remoteVideo.videoWidth} x ${remoteVideo.videoHeight}`);
    });
  }
}

function muteVideoFeed() {
  if ($(this).data('id') === 'camera') {
    muteCameraVideo(!cameraFeedEnabled);
  }
}

function muteCameraVideo(enable) {
  cameraFeedEnabled = enable;
  hostMutedCommand.sendAll({ cameraEnabled: cameraFeedEnabled });
  manager.toggleCameraVideo(cameraFeedEnabled);
}

function toggleFullscreen(event) {
  let elem = document.getElementById('remoteVideo');
  if ($(event.target).data('id') != null) elem = document.getElementById(`remoteVideo${$(event.target).data('id')}`);

  const fullscreen = elem.webkitRequestFullscreen || elem.mozRequestFullScreen || elem.msRequestFullscreen;
  fullscreen.call(elem); // bind the 'this' from the video object and instantiate the correct fullscreen method.
}

// @NotUsed
function goFullscreen() {
  const elem = document.getElementById('remoteVideo');
  console.log('SET FULLSCREEN', elem);
  const fullscreen = elem.webkitRequestFullscreen || elem.mozRequestFullScreen || elem.msRequestFullscreen;
  fullscreen.call(elem); // bind the 'this' from the video object and instantiate the correct fullscreen method.
}

function setupUI(commandsManager, _manager) {
  manager = _manager;
  $('.toggleFullscreen').click(toggleFullscreen);
  $('#muteVideoFeed').click(muteVideoFeed);

  setupVideoSizeListeners();

  $('#toggleContinuity').click(function () {
    if ($(this).text() == 'Continuity') {
      $(this).html('Settings');
    } else {
      $(this).html('Continuity');
    }
    $('#continuityBoardDropdown').toggleClass('hidden');
  });

  $('#togglePrivateRoom input').on('change', (e) => {
    try {
      // Send message to server
      manager.togglePrivateRoom(e.currentTarget.checked);
    } catch (error) {
      console.error('Error activating private room', e);
      e.currentTarget.checked = !e.currentTarget.checked;
    }
  });

  $('#toggleDirectorToSet input').on('change', (e) => {
    manager.toggleDirectorToSet(e.currentTarget.checked);
  });

  $(document).on('click', '.muteMicrophone', function () {
    if ($(this).data('id') === 'camera') {
      manager.toggleCameraAudio(cameraMuted);
      cameraMuted = !cameraMuted;
    }
  });

  // commands
  commandsManager
  // @ NotUsed
    .registerNewCommand('set_fullscreen', goFullscreen)
    .registerCommand(hostMutedCommand);
}

export { setupUI };
